module.exports = __webpack_public_path__ + "assets/hubspot.0bd5ceba.svg";